import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { a11yProps } from '@pages/AdditionalServices/components/WidgetTabs/helpers';
import useAdditionServicesContext from '@pages/AdditionalServices/containers/additionServicesContext';
import useWidgetTabsContext from '@pages/AdditionalServices/containers/widgetTabsContext';
import { COUNT_STATIC_TABS } from '@pages/consts';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Container from './StyledComponents';

const WidgetTabs = () => {
  const { state } = useAdditionServicesContext();
  const { tabs, onChangeTab } = useWidgetTabsContext();
  const { t } = useTranslation('TubsContainer');

  return (
    <Container>
      <Tabs
        variant="scrollable"
        scrollButtons="auto"
        value={tabs.ActiveTab}
        onChange={(_, v) => onChangeTab(v)}
        className={'root-services-tab'}
      >
        {tabs.Tabs.map((tab, index) => (
          <Tab
            key={index}
            label={t(tab.label)}
            disabled={state.IsRestoringState}
            {...a11yProps(index + COUNT_STATIC_TABS)}
          />
        ))}
      </Tabs>
    </Container>
  );
};

export default WidgetTabs;
